import React from 'react';
import { useNavigate, useRouteError } from 'react-router';
import styles from './ErrorPage.module.css';

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIconContainer}>
        <i className="wb-icon wb-icon-exclamation" />
      </div>

      <h1 className={styles.errorTitle}>Oops! Something went wrong.</h1>

      <p className={styles.errorMessage}>
        {error?.message || 'An unexpected error has occurred.'}
      </p>

      {error?.status ? (
        <p className={styles.errorCode}>Error Code: {error.status}</p>
      ) : null}

      <button
        className="btn btn-primary"
        onClick={() => navigate('/', { replace: true })}
      >
        Go to Home
      </button>
    </div>
  );
};

export default ErrorPage;
